__turbopack_context__.v({
  "bubbleNavigationWrapper": "styles-module__xhCiyG__bubbleNavigationWrapper",
  "container": "styles-module__xhCiyG__container",
});
